import {ComponentTypesEnum} from '../../app/shared/enums';
import {BaseControl, SelectControl} from '../../app/shared/classes';

import {IndividualFilterModel} from '@spa/api';

import {
    ReportTableData,
    ReportTableConfigInterface,
    ReportTableActionMenuTypesEnum,
    ReportTableButtonTypesEnum,
    ReportTableActionsEnum,
    ReportTableDataRow, ReportTableColumn
} from '../../app/shared/components';

export const PanelSettingsTradingAccountsFilterControls: BaseControl[] = [
    new SelectControl({
        name: '',
        value: null,
        placeholder: 'Platform',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new SelectControl({
        name: '',
        value: null,
        placeholder: 'Broker',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new SelectControl({
        name: '',
        value: null,
        placeholder: 'Currency',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new SelectControl({
        name: '',
        value: null,
        placeholder: 'Clearing',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new SelectControl({
        name: '',
        value: null,
        placeholder: 'Trade fees plan',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
    new SelectControl({
        name: '',
        value: null,
        placeholder: 'Recurring fees plan',
        validators: [],
        componentType: ComponentTypesEnum.Select,
        options: []
    }),
];

export const PanelSettingsTradingAccountsDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: '',
            value: null,
            hidden: false
        }),
    ];
};

export const PanelSettingsTradingAccountsDataTableConfig: ReportTableConfigInterface = {
    rows: [
        new ReportTableDataRow({
            rowId: 1,
            dataItems: [
                new ReportTableData({
                    colId: 'Platform',
                    value: 'Platform1',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Broker',
                    value: 'Broker1',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Currency',
                    value: 'USD',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Clearing',
                    value: 'Clearing1',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Trade fees plan',
                    value: '',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Recurring fees plan',
                    value: '',
                    hidden: false
                })
            ]
        }),
        new ReportTableDataRow({
            rowId: 2,
            dataItems: [
                new ReportTableData({
                    colId: 'Platform',
                    value: 'Platform2',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Broker',
                    value: 'Broker2',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Currency',
                    value: 'USD',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Clearing',
                    value: 'Clearing2',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Trade fees plan',
                    value: '',
                    hidden: false
                }),
                new ReportTableData({
                    colId: 'Recurring fees plan',
                    value: '',
                    hidden: false
                })
            ]
        })
    ],
    columns: [
        new ReportTableColumn({
            label: 'Platform',
            selector: '',
        }),
        new ReportTableColumn({
            label: 'Broker',
            selector: '',
        }),
        new ReportTableColumn({
            label: 'Currency',
            selector: '',
        }),
        new ReportTableColumn({
            label: 'Clearing',
            selector: '',
        }),
        new ReportTableColumn({
            label: 'Trade fees plan',
            selector: '',
        }),
        new ReportTableColumn({
            label: 'Recurring fees plan',
            selector: '',
        }),
    ],
    hiddenColumnIds: [],
    actionMenu: true,
    actionMenuType: ReportTableActionMenuTypesEnum.Buttons,
    actionMenuItems: [
        {
            buttonType: ReportTableButtonTypesEnum.Delete,
            action: ReportTableActionsEnum.Delete
        },
        {
            buttonType: ReportTableButtonTypesEnum.Edit,
            action: ReportTableActionsEnum.Edit
        },
        {
            buttonType: ReportTableButtonTypesEnum.Preview,
            action: ReportTableActionsEnum.Preview
        }
    ]
};
